import { render, staticRenderFns } from "./pwa_settings_modal.vue?vue&type=template&id=3a9c77bb&scoped=true&"
import script from "./pwa_settings_modal.vue?vue&type=script&lang=js&"
export * from "./pwa_settings_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c77bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a9c77bb')) {
      api.createRecord('3a9c77bb', component.options)
    } else {
      api.reload('3a9c77bb', component.options)
    }
    module.hot.accept("./pwa_settings_modal.vue?vue&type=template&id=3a9c77bb&scoped=true&", function () {
      api.rerender('3a9c77bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/pwa_settings_modal.vue"
export default component.exports